import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 * Handles Emergent Google Auth callback (session_id in URL fragment).
 */
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const hasProcessed = useRef(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/google/session", { session_id: sessionId });
                if (data?.session_token) {
                    localStorage.setItem("itotal4u_token", data.session_token);
                }
                setUser(data.user);
                // Clean URL then redirect
                window.history.replaceState({}, "", window.location.pathname);
                navigate("/dashboard", { replace: true, state: { user: data.user } });
            } catch (err) {
                setError(formatApiError(err, "No pudimos validar tu sesión de Google"));
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="page-center" data-testid="auth-callback">
            <div style={{ textAlign: "center" }}>
                {error ? (
                    <>
                        <div className="alert alert-error" data-testid="auth-callback-error">{error}</div>
                        <button className="btn btn-ghost" onClick={() => navigate("/login")}>Volver al login</button>
                    </>
                ) : (
                    <>
                        <div className="loader loader-lg" />
                        <p className="text-muted mt-4">Validando tu sesión…</p>
                    </>
                )}
            </div>
        </div>
    );
}
